import React, { useState } from "react";

export default function UploadBook() {

  /* ================= FORM STATE ================= */
  const [formData, setFormData] = useState({
    title: "",
    author: "",
    language: "",
    topics: "",
    image: null,
    file: null,
  });


  /* ================= HANDLE INPUT ================= */
  const handleChange = (e) => {

    const { name, value, files } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));

  };


  /* ================= HANDLE UPLOAD ================= */
  const handleSubmit = (e) => {

    e.preventDefault();

    if (!formData.image || !formData.file) {
      alert("Please select Cover Image and PDF File.");
      return;
    }

    console.log("Book Details:", {
      title: formData.title,
      author: formData.author,
      language: formData.language,
      topics: formData.topics,
    });

    console.log("Cover Image:", formData.image);

    console.log("PDF File:", formData.file);

    alert("PDF Uploaded Successfully ✅");


    /* ================= RESET FORM ================= */

    setFormData({
      title: "",
      author: "",
      language: "",
      topics: "",
      image: null,
      file: null,
    });

    e.target.reset();

  };


  return (
    <div className="container my-5">

      {/* ================= PAGE TITLE ================= */}

      <div className="text-center mb-5">

        <h2 className="fw-bold">
          📤 Upload New Book
        </h2>

        <p className="text-muted">
          Upload a new Islamic book to the Digital Library.
        </p>

      </div>


      {/* ================= UPLOAD FORM ================= */}

      <form
        onSubmit={handleSubmit}
        className="card border-0 shadow-sm p-4 p-md-5"
      >

        <div className="row g-4">


          {/* ================= BOOK TITLE ================= */}

          <div className="col-md-6">

            <label className="form-label fw-semibold">
              Book Title
            </label>

            <input
              type="text"
              name="title"
              className="form-control"
              placeholder="Enter Book Title"
              value={formData.title}
              onChange={handleChange}
              required
            />

          </div>


          {/* ================= AUTHOR ================= */}

          <div className="col-md-6">

            <label className="form-label fw-semibold">
              Author Name
            </label>

            <input
              type="text"
              name="author"
              className="form-control"
              placeholder="Enter Author Name"
              value={formData.author}
              onChange={handleChange}
              required
            />

          </div>


          {/* ================= LANGUAGE ================= */}

          <div className="col-md-6">

            <label className="form-label fw-semibold">
              Language
            </label>

            <input
              type="text"
              name="language"
              className="form-control"
              placeholder="Enter Language"
              value={formData.language}
              onChange={handleChange}
              required
            />

          </div>


          {/* ================= TOPICS ================= */}

          <div className="col-md-6">

            <label className="form-label fw-semibold">
              Topics
            </label>

            <input
              type="text"
              name="topics"
              className="form-control"
              placeholder="Enter Topics"
              value={formData.topics}
              onChange={handleChange}
              required
            />

          </div>


          {/* ================= COVER IMAGE ================= */}

          <div className="col-md-6">

            <label className="form-label fw-semibold">
              Upload Cover Image
            </label>

            <input
              type="file"
              name="image"
              accept="image/*"
              className="form-control"
              onChange={handleChange}
              required
            />

          </div>


          {/* ================= PDF FILE ================= */}

          <div className="col-md-6">

            <label className="form-label fw-semibold">
              Upload PDF File
            </label>

            <input
              type="file"
              name="file"
              accept="application/pdf"
              className="form-control"
              onChange={handleChange}
              required
            />

          </div>


          {/* ================= SUBMIT BUTTON ================= */}

          <div className="col-12 text-center mt-4">

            <button
              type="submit"
              className="btn btn-success px-5 py-2"
            >
              <i className="bi bi-cloud-arrow-up me-2"></i>
              Upload PDF
            </button>

          </div>

        </div>

      </form>

    </div>
  );
}